<template>
  <v-form @submit.prevent="submit">
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="4"
      >
        <v-card>
          <v-toolbar
            color="primary"
            dark
          >
            <v-toolbar-title>
              Unternehmensanmeldung
            </v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-progress-circular
              v-if="loading"
              indeterminate
            />
            <!--<alert />-->
          </v-card-text>
          <v-card-actions>
            <v-container>
              <v-row
                v-for="backend in loginBackendInfo.login_backends"
                :key="backend.name"
              >
                <v-col cols="12">
                  <v-btn
                    color="primary"
                    block
                    type="submit"
                    :disabled="loading"
                    :loading="loading"
                    :href="backend.url"
                  >
                    Anmelden mit {{ backend.name }}
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-btn
                    block
                    color="primary"
                    exact
                    outlined
                    :to="{name: 'login'}"
                  >
                    Zurück zur normalen Anmeldung
                  </v-btn>
                </v-col>
              </v-row>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    loginIdentifier: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      loading: false,
      loginBackendInfo: null,
    }
  },
  async created () {
    this.loading = true
    try {
      let loginBackendInfo = await this.getTenantLoginBackendInfo({tenantLoginIdentifier: this.loginIdentifier})
      if (!loginBackendInfo) {
        const result = await this.checkLoginTenant({
          tenantLoginIdentifier: this.tenantLoginIdentifier,
        })
        loginBackendInfo = result.tenantInfo
      }
      this.$set(this, "loginBackendInfo", loginBackendInfo)
    } finally {
      this.loading = false
    }
  },
  methods: {
    submit () {
    },
    ...mapActions(['getTenantLoginBackendInfo']),
  },
}
</script>
